"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var formik_1 = require("formik");
var globalSlice_1 = require("../../../features/global/globalSlice");
var AppFooter_1 = __importDefault(require("../../../components/AppFooter/AppFooter"));
var SmsVerificationPhone_1 = __importDefault(require("./SmsVerificationPhone"));
var Button_1 = __importDefault(require("../../../components/Button"));
var smsVerifySlice_1 = require("../../../features/smsVerify/smsVerifySlice");
var smsVerificationSchema_1 = __importDefault(require("../../../schemas/smsVerificationSchema"));
var Routes_1 = require("../../../constants/Routes");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var SmsVerification = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var sendCode = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(smsVerifySlice_1.sendPhoneToVerify({ phone: values.phone }))];
                case 1:
                    _a.sent();
                    history.push({
                        pathname: Routes_1.Routes.SmsVerificationCode.path,
                        state: { phone: values.phone },
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 400) {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('SMS_PAGE.PHONE_EXIST'),
                            appearance: 'error',
                        }));
                    }
                    else {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('SMS_PAGE.PHONE_SEND_FAILED'),
                            appearance: 'error',
                        }));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setPhone = function (formikProps, numbers) {
        formikProps.setFieldValue('phone', numbers);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(formik_1.Formik, { initialValues: {
                phone: '',
            }, validationSchema: smsVerificationSchema_1.default, onSubmit: sendCode }, function (formikProps) { return (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.sms_verify },
                react_1.default.createElement(SmsVerificationPhone_1.default, { onChange: function (numbers) {
                        return setPhone(formikProps, numbers);
                    } }),
                react_1.default.createElement(Button_1.default, { className: styles_module_scss_1.default.btn_verify, disabled: !formikProps.dirty || !formikProps.isValid, type: "submit" }, t('SMS_PAGE.VERIFY'))))); }),
        react_1.default.createElement(AppFooter_1.default, { layout: 'SECONDARY' })));
};
exports.default = SmsVerification;
